import React from "react";
import * as SVGLoaders from "svg-loaders-react";
import PreloaderTypeEnum from "../../enums/preloader-type.enum";
import PriorityEnum from "../../enums/priority.enum";
import SizeEnum from "../../enums/size.enum";
import classMap from "../../helpers/classMap";
import PreloaderProps from "./preloader.props";

const Preloader = (props: PreloaderProps) => {
  const type: PreloaderTypeEnum = props.type ?? PreloaderTypeEnum.GRID;
  const Loader = SVGLoaders[type];

  return (
    <div
      className={classMap(
        "mpng-ux-preloader",
        type.toLowerCase(),
        "size",
        props.size || SizeEnum.SMALL,
        props.className
      )}
    >
      <Loader
        className={classMap(
          "w-100 h-100",
          `fill fill-${props.fill ?? PriorityEnum.PRIMARY}`,
          props.stroke ? `stroke stroke-${props.stroke}` : ""
        )}
        strokeOpacity={props.strokeOpacity || 1}
      />
    </div>
  );
};

export default Preloader;
